var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipelinesMerge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 23.9998L11 15.5264",
    stroke: "#2968C9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24.0007L15.2857 19.1587",
    stroke: "#2968C9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 15.5259C10.4 15.8572 10.6686 16.1259 11 16.1259C11.3314 16.1259 11.6 15.8572 11.6 15.5259H10.4ZM11.4243 0.575727C11.1899 0.341412 10.8101 0.341412 10.5757 0.575727L6.75736 4.3941C6.52304 4.62842 6.52304 5.00832 6.75736 5.24263C6.99167 5.47695 7.37157 5.47695 7.60589 5.24263L11 1.84852L14.3941 5.24263C14.6284 5.47695 15.0083 5.47695 15.2426 5.24263C15.477 5.00832 15.477 4.62842 15.2426 4.3941L11.4243 0.575727ZM11.6 15.5259L11.6 0.99999H10.4L10.4 15.5259H11.6Z",
    fill: "#2968C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelinesMerge);
export default __webpack_public_path__ + "static/media/pipelines-merge.288b2d641da22049695984168c9b6956.svg";
export { ForwardRef as ReactComponent };